function updateDate(cstmDate) {
    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(now.getDate() + 1);
    
    const formattedDate = `${daysOfWeek[tomorrow.getDay()]}, ${months[tomorrow.getMonth()]} ${tomorrow.getDate()}`;
    cstmDate.innerText = formattedDate;
    
    const msUntilMidnight = new Date(now.setHours(24, 0, 0, 0)) - now;
    setTimeout(() => {
        updateDate(cstmDate);
        setInterval(() => updateDate(cstmDate), 24 * 60 * 60 * 1000);
    }, msUntilMidnight);
}

let cstmDate = document.getElementById('cstmdate');
if (cstmDate) {
    updateDate(cstmDate);
}

